/**
 *  Notificaciones (notificaciones/*, aplicacion/notificaciones/*) → /api/v1/notifications
 *  Forma vieja: {IdNotificacion, Mensaje, Status}; historial {IdLog, Fecha,
 *  Proyecto, Unidad, Persona} con 'Todos' cuando el envío no filtraba.
 */
import api from '../apiV1';
import { fail, done, list } from './index';

// Los selectores mandan 0 (o '') para "todos"; v1 los quiere omitidos.
const target = (data) => {
   const t = {};
   const add = (key, v) => {
      const n = Number(v);
      if (n > 0) t[key] = n;
   };
   add('projectId', data.IdProyecto);
   add('unitId', data.IdUnidad);
   add('personId', data.IdPersona);
   return t;
};

// send manda la notificación y regresa la respuesta vieja de /enviar.
async function send(id, data) {
   const res = await api.post(`notifications/${id}/send`, target(data));
   if (!res.ok) {
      if (res.status === 400) {
         return { error: true, message: 'No se encontró ningún propietario para enviar la notificación.' };
      }
      return fail(res);
   }
   if (res.data && res.data.pushFailed) {
      // Quedó en la bandeja de la app; solo falló el push.
      return { completed: true, message: res.message };
   }
   return { completed: true };
}

export default {
   'GET notificaciones/get': async () => {
      const res = await api.get('notifications');
      if (!res.ok) return fail(res);
      // Ningún SP cambia el Status, así que todas salen como 'No Enviado'.
      return list((res.data || []).map((n) => ({ IdNotificacion: n.id, Mensaje: n.message, Status: 'No Enviado' })));
   },

   'POST notificaciones/update': async (data) =>
      done(await api.put(`notifications/${data.IdNotificacion}`, { message: data.Mensaje || '' })),

   // En Koa el alta también enviaba; aquí son dos pasos en v1.
   'POST aplicacion/notificaciones/create': async (data) => {
      const created = await api.post('notifications', { message: data.Mensaje || '' });
      if (!created.ok) return fail(created);
      const sent = await send(created.data.id, data);
      if (sent.error) {
         return { error: true, message: `La notificación se guardó, pero no se envió: ${sent.message}` };
      }
      return { created: true };
   },

   'POST aplicacion/notificaciones/enviar': async (data) => send(data.IdNotificacion, data),

   'GET aplicacion/notificaciones/get/history': async (data) => {
      const res = await api.get(`notifications/${data.IdNotificacion}/deliveries`);
      if (!res.ok) return fail(res);
      return list(
         (res.data || []).map((d) => ({
            IdLog: d.id,
            Fecha: d.sentAt,
            Proyecto: d.project || 'Todos',
            Unidad: d.unit || 'Todos',
            Persona: d.person || 'Todos',
         }))
      );
   },
};
